<script>
import ModelCreateModal from './modal-create';
import FormsModel from "@/components/forms/jala-farm";

export default {
  extends: ModelCreateModal,
  props: {
    modalTitle: {default() { return this.lodash.startCase(this.$t('jala_farms.singular')) }},
    resourceRoute: {default: 'jala_farms'},
    modelVariable: {default: 'farm'},
    form: {default() { return FormsModel; }}
  },
  methods: {
    store(value) {
      return this.$axios.post('/jala/farms', value);
    }
  },
}
</script>
